module.exports = __webpack_public_path__ + "img/首页二维码3.a38e2576.png";